export default __webpack_public_path__ + "static/media/WhoEatsWhat_01.80bd51f0.png";